var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverViewBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 263,
    height: 250,
    viewBox: "0 0 263 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M138.945 165.263C56.8049 172.047 -72.051 164.393 69.6457 79.5082C211.342 -5.37657 226.177 112.969 215.882 182.752L141.512 160.972",
    stroke: "#09AEEF",
    strokeWidth: 7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.821 163.716C52.8214 96.7156 -6.77857 -17.7844 138.821 60.2156C284.421 138.216 190.488 211.716 125.321 238.716L105.821 163.716",
    stroke: "#09AEEF",
    strokeWidth: 7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverViewBg);
export default __webpack_public_path__ + "static/media/overViewBG.9e2cc00324b26856a9f32348b8455157.svg";
export { ForwardRef as ReactComponent };